import { useQuery, useMutation } from '@tanstack/react-query';
import { api } from '../api/client';

export function useTableCheckIn(tableId: string) {
  const checkInMutation = useMutation({
    mutationFn: (payload: { playerName: string; gameType: string; qrCodeType: 'player1' | 'player2' }) =>
      api.checkIn(tableId, payload),
  });

  return {
    checkIn: checkInMutation.mutateAsync,
    isCheckingIn: checkInMutation.isPending,
    checkInData: checkInMutation.data,
    error: checkInMutation.error,
  };
}

export function useTableStatus(tableId: string, refetchInterval = 2000) {
  return useQuery({
    queryKey: ['tables', tableId, 'status'],
    queryFn: () => api.getTableStatus(tableId),
    enabled: !!tableId,
    refetchInterval,
  });
}

export function useGameTypes() {
  return useQuery({
    queryKey: ['game-types'],
    queryFn: () => api.getGameTypes(),
  });
}
